import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import {DirectoryCategories} from 'src/app/layout/Directory/DirectoryCategories';
import {
  SidebarLinkSystem,
  SystemDirectoryConfig,
} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

export const SystemDirectoryPage: React.FC = () => {
  useSetDocumentTitle('System');

  return (
    <ContentWrapper>
      <Stack gap="lg">
        <PageHeader>
          <PageHeader.Title
            icon={SidebarLinkSystem.icon}
            subtitle="Platform-wide administration across all instances">
            System
          </PageHeader.Title>
        </PageHeader>
        <DirectoryCategories categories={SystemDirectoryConfig} />
      </Stack>
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AdminSystem(),
  element: <SystemDirectoryPage />,
  isPrivate: true,
  requireSuperAdmin: true,
});
